import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
}

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (hasPhoneVerified) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: "Raport o deweloperze"
    };
}
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
}

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (hasPhoneVerified) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: "Raport o deweloperze"
    };
}
